import '@babylonjs/core/Materials/standardMaterial';
import { MeshBuilder } from '@babylonjs/core/Meshes/meshBuilder';
import { Mesh } from '@babylonjs/core/Meshes/mesh';
import { Color3, Vector3 } from '@babylonjs/core/Maths/math';
import { StandardMaterial } from '@babylonjs/core/Materials/standardMaterial';
import { FresnelParameters } from '@babylonjs/core/Materials/fresnelParameters';

import { PearlMesh } from '../Entity/pearlMesh';
import { EnvironmentSystem } from './environmentSystem';
import { SoundManager } from './sound';

/**
 * Manage all the essential assets needed to build a 3D scene (Engine, Scene Cameras, etc)
 *
 * The system is really important as it is often sent in every other class created to manage core assets
 */

export class MeshSystem extends EnvironmentSystem {

   
    /**
     * Creates a new System
     * @param canvas Element where the scene will be drawn
     */

    public soundManager: SoundManager;

    constructor(canvas: HTMLCanvasElement) {
        super(canvas);
        this.addHeart();
        this.addDustMesh();
        this.addUpperDustMesh();
        this.addPlanetMesh();

        this.soundManager = new SoundManager(this.scene);
    }

    dustMesh: Mesh;
    addDustMesh() {
        this.dustMaterial = this.getNewDustMaterial();
        this.dustMaterial.emissiveColor = new Color3(1, 1, 0);
        this.dustMesh = this.getNewDust();
        this.dustMesh.material = this.dustMaterial; 
    }

    upperDustMesh: Mesh;
    upperDustMaterial: StandardMaterial;
    addUpperDustMesh() {
        this.upperDustMaterial = this.getNewDustMaterial();
        this.upperDustMaterial.emissiveColor = new Color3(1, 1, 1);
        this.upperDustMesh = this.getNewDust();
        this.upperDustMesh.material = this.upperDustMaterial;
        this.upperDustMesh.scaling = new Vector3(0.2, 0.2, 0.2);
    }
    
    getNewDust(): Mesh {
        // this.mesh = MeshBuilder.CreateIcoSphere(this.key + "star", { radius: 1, flat: true, subdivisions: 2 }, this.system.scene);
        // this.mesh.isBlocker = false;
        let dustMesh = MeshBuilder.CreateSphere("dust", { diameter: 1 }, this.scene);
        dustMesh.alwaysSelectAsActiveMesh = true;
        dustMesh.doNotSyncBoundingInfo = true;
        dustMesh.isVisible = false;
        return dustMesh;
    }
    
    dustMaterial: StandardMaterial;
    getNewDustMaterial(): StandardMaterial {
        let dustMaterial = new StandardMaterial("dustMaterial1", this.scene);
        dustMaterial.maxSimultaneousLights = 0;
        dustMaterial.diffuseColor = Color3.Black();
        dustMaterial.specularColor = Color3.Black();
        return dustMaterial;
    }

    public heart: Mesh;

    public heartMaterial: StandardMaterial;

    private addHeart() {
        // this.heart = MeshBuilder.CreateIcoSphere(this.key + "star", { radius: 1, flat: true, subdivisions: 2 }, this.system.scene);
        this.heart = MeshBuilder.CreateSphere("heart", { diameter: 2.8 }, this.scene);
        // Not always active as we check if heart in frustrum for opti
        this.heart.alwaysSelectAsActiveMesh = true;
        this.heart.doNotSyncBoundingInfo = true;
        this.heart.isBlocker = false;
        this.heart.isVisible = false;

        this.heartMaterial = new StandardMaterial("heartMaterial", this.scene);
        this.heartMaterial.backFaceCulling = false;
        this.heartMaterial.maxSimultaneousLights = 0;
        // console.log(this.heartMaterial);
        // this.system.starGlowLayer.addIncludedOnlyMesh(this.heart);
    }

    planetMesh: PearlMesh;
    addPlanetMesh() {
        // this.planetMesh = MeshBuilder.CreatePolyhedron("surface", { type: 2, size: 0.5 }, this.scene);
        this.planetMesh = new PearlMesh("planet", this.scene);
        // Not always active as we check if star in frustrum for opti
        this.planetMesh.alwaysSelectAsActiveMesh = true;
        this.planetMesh.doNotSyncBoundingInfo = true;
        this.planetMesh.isBlocker = false;
        this.planetMesh.isVisible = false;

        this.planetMaterial = new StandardMaterial("planetMaterial", this.scene);
        // this.planetMaterial.wireframe = true;
        this.planetMaterial.emissiveColor = new Color3(1, 1, 1);
        this.planetMaterial.emissiveFresnelParameters = new FresnelParameters();
        this.planetMaterial.emissiveFresnelParameters.power = 1;
        this.planetMaterial.disableLighting = true;

        this.planetMesh.material = this.planetMaterial;

    }

    unfreezeMaterials() {
        // for (let i = 0; i < this.scene.materials.length; i++) {
        //     const material = this.scene.materials[i];
        //     material.unfreeze();
        // }
        this.dustMaterial.unfreeze();
        this.planetMaterial.unfreeze();
        this.ribbonMaterial.unfreeze();
    }

    freezeMaterials() {
        // for (let i = 0; i < this.scene.materials.length; i++) {
        //     const material = this.scene.materials[i];
        //     material.freeze();
        // }
        this.dustMaterial.freeze();
        this.planetMaterial.freeze();
        this.ribbonMaterial.freeze();
    }

    checkMaterials() {
        // Freeze all material to have better performance
        this.unfreezeMaterials();
        this.freezeMaterials();
        // setTimeout(() => {
        //     this.freezeMaterials();
        // }, 100);
    }
}